import { Line } from '@react-three/drei'
import type { EstadoElevacaoPainel } from '../../dominio/didatico/elevacaoPainel'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { AlargadorHolmatro3D } from './AlargadorHolmatro3D'
import { pontaDoBraco } from './geometriaAlargador'
import { anguloComPreparo } from './animacaoFerramenta'
import { TransicaoSuave } from '../componentes/TransicaoSuave'
import { Rotulo3D } from '../componentes/Rotulo3D'
import { pontosElevacaoPainel, poseAlargadorElevacao } from './zonasElevacaoPainel'
import type { IdPortaOficina } from './zonasOperacaoPorta'

export function ElevacaoPainel3D({ perfil, idPorta, estado, mostrarAlargador, mostrarDobra, progressoFerramenta = 0, afastamento = 0, preparo = 1, estadoInicial, deslizar = false }: {
  perfil: PerfilVeiculo; idPorta: IdPortaOficina; estado: EstadoElevacaoPainel; mostrarAlargador: boolean; mostrarDobra: boolean; progressoFerramenta?: number; afastamento?: number
  /** Player: 0 = garras no estado inicial (no ar), 1 = pose de trabalho. */
  preparo?: number
  estadoInicial?: 'aberto' | 'fechado' | null
  /** Player: o alargador desliza da dobra da aba para os apoios de elevação. */
  deslizar?: boolean
}) {
  const p = pontosElevacaoPainel(perfil, idPorta, estado.alturaPainel, estado.progressoDobra)
  const pose = poseAlargadorElevacao(p.apoioInferior, p.apoioSuperior, p.sinal)
  const anguloPinca = 0.42 * (1 - progressoFerramenta) + 0.025
  const alcancePinca = pontaDoBraco(anguloPinca)[0] * 0.72
  // Um alargador só, para a dobra da aba e para a elevação: entre os dois passos
  // ele desliza de um ponto ao outro em vez de sumir e reaparecer.
  const modo = mostrarDobra ? 'dobra' : (estado.alargadorPosicionado || mostrarAlargador) ? 'elevacao' : null
  // Já posicionado entre os apoios, ele não solta a peça entre um passo e outro.
  const preparoEfetivo = modo === 'elevacao' && estado.alargadorPosicionado ? 1 : preparo
  const giroY = p.sinal > 0 ? Math.PI : 0
  return <group name="elevacao-painel">
    {modo && <group position={modo === 'elevacao' ? [p.sinal * (estado.alargadorPosicionado ? 0 : afastamento), 0, 0] : [0, 0, 0]}>
      <group
        position={modo === 'dobra' ? [p.pontaAba[0] + p.sinal * (alcancePinca + afastamento), p.pontaAba[1], p.pontaAba[2]] : pose.posicao}
        rotation={modo === 'dobra' ? [0, giroY, 0] : [pose.giroX, pose.giroY, 0]}
        scale={modo === 'dobra' ? 0.72 : pose.escala}>
        <TransicaoSuave chave={modo} ativa={deslizar}>
          <AlargadorHolmatro3D name={modo === 'dobra' ? 'alargador-dobrando-aba' : 'alargador-elevando-painel'}
            anguloMandibula={anguloComPreparo('alargador', modo === 'dobra' ? anguloPinca : pose.anguloMandibula, preparoEfetivo, estadoInicial)}
            ativa={modo === 'dobra' ? progressoFerramenta > 0 : estado.alturaPainel > 0} />
        </TransicaoSuave>
      </group>
      {modo === 'elevacao' && <Line points={[p.apoioInferior, p.apoioSuperior]} color="#55d98a" lineWidth={2} transparent opacity={0.65} />}
    </group>}
    {estado.acionado && <Rotulo3D posicao={[p.apoioSuperior[0], perfil.cinturaY + estado.alturaPainel + 0.18, p.apoioSuperior[2]]}
      texto="Painel elevado" subtexto="Espaço junto às pernas ampliado" variante="achado" sempreVisivel fator={3} />}
  </group>
}
